module.exports = __webpack_public_path__ + "img/chrismas_modal.1ad63579.png";